module.exports = __webpack_public_path__ + "static/img/box-open.6c291ef8.png";